/// <amd-module name="VSS/Features/Directory/DirectoryContracts" />
/**
 * Exception info
 */
export interface ExceptionInfo {
    exceptionMessage: string;
    additionalMessages?: string[];
    primaryLinkText?: string;
    primaryLinkHref?: string;
    secondaryLinkText?: string;
    secondaryLinkHref?: string;
}

/** Struct representing an identity that owns an artifact */
export interface IArtifactOwner {
    /** The identity id */
    id: string;
    /** The identity name */
    name: string;
    /** Is this identity a team? */
    isTeam: boolean;
}
/**
 * A base directory artifact
 * Those with additional artifact properties should extend this interface and use in generic components where appropriate
 */
export interface IDirectoryArtifact {
    /** A unique id for the artifact */
    id: string;
    /** The display name of the artifact */
    name: string;
    /** The owners of the artifact */
    owners: IArtifactOwner[];
    /** The url of the artifact */
    url: string;
}

export interface IFavoriteData {
    id: string;
    artifactId: string;
    artifactName: string;
    artifactProperties: { [key: string]: string };
    isDeleted: boolean;
}
